import dm1 from '../../assets/dataModel/dm_main.png';
import Image from 'next/image';
import { motion } from 'framer-motion';
import airTemperatureImg from '../../assets/weather/airtemp.png';
import airHumidityImg from '../../assets/weather/air_humidity.png';
import airPressureImg from '../../assets/weather/air_pressure.png';
import rainfallChanceImg from '../../assets/weather/rainfall.png';
import rainfallAmountImg from '../../assets/weather/rainfall_amount.png';
import windSpeedImg from '../../assets/weather/wind_speed.png';
import windDirectionImg from '../../assets/weather/wind_direction.png';
import leafWetnessImg from '../../assets/weather/leaf_wetness.png';
import sunshineHoursImg from '../../assets/weather/sunshine_hours.png';
import EvapotranspirationImg from '../../assets/weather/evaporation.png';
import MetaHead from '@/Components/MetaHead';

import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';
import ContentText from '@/Components/ContentText';
import Button from '@/Components/Button';
import Link from 'next/link';

const WeatherModelData = [
  {
    title: ' Air Temperature',
    images: airTemperatureImg,
  },
  {
    title: 'Air humidity',
    images: airHumidityImg,
  },
  {
    title: 'Air Pressure',
    images: airPressureImg,
  },
  {
    title: 'Rainfall Chances',
    images: rainfallChanceImg,
  },
  {
    title: ' Rainfall amount',
    images: rainfallAmountImg,
  },
  {
    title: 'Wind Speed',
    images: windSpeedImg,
  },
  {
    title: 'Wind Direction',
    images: windDirectionImg,
  },
  {
    title: 'Leaf Wetness',
    images: leafWetnessImg,
  },
  {
    title: 'Sunshine hours',
    images: sunshineHoursImg,
  },
  {
    title: 'Evapotranspiration',
    images: EvapotranspirationImg,
  },
];

export default function WeatherModel() {
  return (
    <main>
      <MetaHead title="Weather Model | How Fyllo works?" />
      <div className="py-8 px-4 mx-auto max-w-screen-xl text-left lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm">
          <MainHeading text="Weather Models" />
          <SubHeading
            text=" We predict various parameters for microclimate around farms. Our weather models are 50% more accurate
            compared to global weather models like GFS and ECMWF. We have 30+ weather models predicting following
            parameters."
          />
        </div>
      </div>

      <div className="px-4  mx-auto max-w-screen-xl text-left lg:px-6">
        <ul className="w-full gap-4 py-4 mb-6 md:py-8 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl grid sm:grid-cols-2 md:grid-cols-3 place-items-center">
          {WeatherModelData.map((it, i) => {
            return (
              <div
                key={i}
                className={
                  'p-2 border-2 border-fyllo-400 rounded-xl w-full flex gap-2  items-center justify-center ' +
                  (i === WeatherModelData.length - 1 ? ' col-start-2' : ' ')
                }
              >
                <Image
                  className="w-12 h-12 object-contain"
                  src={it.images}
                  alt={it.title}
                  sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
                />
                <p className=" text-center font-semibold">{it.title}</p>
              </div>
            );
          })}
        </ul>
        <h2 className="text-start mb-4 text-2xl font-bold tracking-tight text-fyllo-800 ">
          Fyllo weather models are machine learning based and are continuously retrained using ground data collected
          from our in-situ IoT devices and other sources.
        </h2>

        <h3 className="text-start mb-4 text-xl font-bold tracking-tight text-gray-700 ">
          Following are the major inputs to our models.
        </h3>
        <ul className="mb-6 space-y-1 font-light text-gray-500 lg:mb-8   list-inside list-disc">
          <li>Statical Macro Climatic Weather models like GFS, ECMWF</li>
          <li>Machine Learning weather models like GRAPH</li>
          <li>Real time Data from on-field devices of Fyllo</li>
        </ul>

        <h2 className="text-start mb-4 text-xl font-bold tracking-tight text-gray-700 ">
          Our weather models are divided into three categories:
        </h2>
        <ul className="mb-6  space-y-1  font-light text-gray-500 lg:mb-8   list-inside list-disc">
          <li> NowCast models providing prediction for next few hours</li>
          <li>Hourly models providing prediction for next 100 hours</li>
          <li>Daily weather prediction models providing weather forecast for upto 15 days.</li>
        </ul>

        <Link href="/contact#contact_form" className="w-full flex justify-center p-5">
          <Button size="lg" styles="flex items-center">
            <p className="text-white font-medium">Connect here to know more about Fyllo Models</p>
            <svg
              aria-hidden="true"
              className="w-4 h-4 ml-2 -mr-1"
              fill="white"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
          </Button>
        </Link>
      </div>
    </main>
  );
}
